import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import "./styles.css";
import { goBack } from "../../../../utils/gotoback";
import { loadingShow } from "../../../../services/PostAPI";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useStyles } from "../style";
import {
  basicDetail,
  datagetbyid,
  driverageDD,
  editMode,
  statusDD,
  typeDD,
} from "../CreateReservationsReservations/constant";
import { Box, Container, Grid, Typography } from "@mui/material";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledCalendarWithFloatingLabel from "../../../../common/EzForm/EzControlledCalendar/WithFloatingLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { ReservationsReservationsBreadcrumb } from "../../ReservationsReservations/CreateReservationsReservations/constant";
import { hourslist } from "../../../Location/CreateLocation/constant";
import EzControlledInputAreaWithFloatingLabel from "../../../../common/EzForm/EzControlledInputArea/WithFloatingLabel";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import HeatPumpIcon from "@mui/icons-material/HeatPump";
import SpeedIcon from "@mui/icons-material/Speed";
import CardICON from "../../../../images/car-door.png";
import { Panel } from "primereact/panel";
import {
  formatDates,
  formatDatesHyphan,
  formatDatesMMDDYYYYY,
  formatAmount,
} from "../../../../utils";
import {
  cancelResonsDD,
  paymentStatusDD,
} from "../../../Renters/RentersRegisteredRenters/CreateRentersRegisteredRenters/constant";

const ViewReservationsReservationsComponent = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    history,
    initCreateReservationsReservationsScreen,
    createReservationsReservations,
    searchReservationsReservations,
    editReservationsReservations,
    isReservationsReservationsDetailSuccess,
    isEdit,
    isView,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    vehicleModelDD,
    isVehicleModelDDSuccess,
    isVehicleModelDDError,
    locationDD,
    vehicleCategoryDD,
    updateCancellationStatus,
    updatePaymentStatus,
    sendConfirmationEmail,
    isUpdatePaymentStatusSuccess,
    isUpdateCancellationStatusSuccess,
    syncToSofiac,
    sofiacReservationStatus,
  } = props;
  console.log("check props of compoemnt", props);

  const classes = useStyles();

  const {
    control,
    formState: { errors, isDirty },
    watch,
    register,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", formFieldValueMap);
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const cancellation = watch("reasonCancel");
  const otherreson = watch("reasonOtherDetails");
  const ref = useRef(null);
  let searchfiled = {
    pickUpDate: new Date(),
    dropOffDate: new Date(),
    locationId: 0,
    categoryId: 0,
    pickUpTime: "10:00AM",
    dropOffTime: "10:00AM",
    driverAge: 2,
  };
  const {
    handleSubmit: handleSubmit2,
    control: control2,
    register: register2,
    reset: resetForm2,
    formState: { errors: errors2, isDirty: isDirty2 },
    watch: watch2,
  } = useForm({
    defaultValues: useMemo(() => {
      console.log("check value come or not", searchfiled);
      return searchfiled;
    }, [searchfiled]),
  });

  let otherData = datagetbyid.Other;
  const [amountTotal, setAmountTotal] = useState(0);

  const [extraamountTotal, setExtraAmountTotal] = useState(0);
  const [damageTotal, setDamageTotal] = useState(0);
  const [additionalDriverTotal, setAdditionalDriverTotal] = useState(0);
  const [glassTiresTotal, setGlassTiresTotal] = useState(0);
  const [equipmentTotal, setEquipmentTotal] = useState(0);
  const [outofProvinceTotal, setOutofProvinceTotal] = useState(0);
  const [extraMileageTotal, setExtraMileageTotal] = useState(0);

  const [other, setOther] = useState({}); //otherData
  const [paymentOption, setPaymentOption] = useState([]); //payOptionData
  const [damage, setDamage] = useState([]); //damageData
  const [additionalDriver, setAdditionalDriver] = useState([]);
  const [glassTires, setGlassTires] = useState([]); //glassTiresData
  const [equipment, setEquipment] = useState([]); //equipmentData
  const [outofProvince, setOutofProvince] = useState([]); //outofProvinceData
  const [extraMileage, setExtraMileage] = useState([]); //extraMileageData
  const [extraBoll, setExtraBoll] = useState(false);
  const [searchPayload, setSearchPayload] = useState({});
  const otherDis = datagetbyid.Other.filter(
    (item) => item.name === "Pay now discount"
  );

  // Track where the user came from
  const cameFromDetailReport = location.state?.fromDetailReport;
  const cameFromDailyManifest = location.state?.fromDailyManifest;
  const cameFromPrepaidBookings = location.state?.fromPrepaidBookings;

  const navigateToReservationsReservationsScreen = () => {
    if (cameFromDailyManifest) {
      navigate(APP_URLS.RESERVATIONS_DAILYMANIFESTREPORT.HOME, { state: { fromDailyManifest: true } });
    } else if (cameFromPrepaidBookings) {
      navigate(APP_URLS.RESERVATIONS_PREPAIDBOOKINGSREPORT.HOME, { state: { fromPrepaidBookings: true } });
    } else if (cameFromDetailReport) {
      navigate(APP_URLS.RESERVATIONS_DETAILREPORT.HOME, { state: { fromDetail: true } });
    } else {
      navigate(APP_URLS.RESERVATIONS_RESERVATIONS.HOME, { state: { fromDetail: true } });
    }
  };

  const [inclusiveRate, setInclusiveRate] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const prevUpdatePaymentStatusSuccess = useRef(isUpdatePaymentStatusSuccess);
  const prevUpdateCancellationStatusSuccess = useRef(isUpdateCancellationStatusSuccess);

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setInclusiveRate(checked);
  };

  useEffect(() => {
    initCreateReservationsReservationsScreen();
  }, []);

  useEffect(() => {
    // Only show toast if value changed from false to true
    if (isUpdatePaymentStatusSuccess && !prevUpdatePaymentStatusSuccess.current) {
      setToastMessage("Notes updated successfully!");
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
    prevUpdatePaymentStatusSuccess.current = isUpdatePaymentStatusSuccess;
  }, [isUpdatePaymentStatusSuccess]);

  useEffect(() => {
    // Only show toast if value changed from false to true
    if (isUpdateCancellationStatusSuccess && !prevUpdateCancellationStatusSuccess.current) {
      setToastMessage("Reservation cancelled successfully!");
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
    prevUpdateCancellationStatusSuccess.current = isUpdateCancellationStatusSuccess;
  }, [isUpdateCancellationStatusSuccess]);

  useEffect(() => {
    if (isReservationsReservationsDetailSuccess) {
      console.log("SDFSDFF", formFieldValueMap.paymentStatus);
      reset({
        ...formFieldValueMap,
        reasonCancel: parseInt(formFieldValueMap.reasonCancel),
      });
    }
  }, [isReservationsReservationsDetailSuccess]);

  const handleCancel = () => {
    const stringifiedData = {
      reasonOtherDetails: otherreson,
      reasonCancel: cancellation,
      reservationId: id,
    };
    updateCancellationStatus(stringifiedData);
  };

  const { id } = useParams();

  const handleSendConfirmationEmail = () => {
    if (id) {
      sendConfirmationEmail({ reservationId: id });
    }
  };

  const onSubmit = (data) => {
    let newData = data;
    newData["userId"] = localStorage.getItem("userId");

    const stringifiedData = {
      note: data?.note,
      paymentStatus: data?.paymentStatus,
      reservationId: id,
    };

    isEdit
      ? updatePaymentStatus(stringifiedData)
      : updatePaymentStatus(stringifiedData);
  };

  const getToastProps = () => {
    if (showSuccessToast) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: toastMessage,
        shouldShowToast: true,
      };
    }
    const toastTitle = "Please select category from list";
    return {
      severity: TOAST_SEVERITY.ERROR,
      toastTitle,
      shouldShowToast: false,
    };
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };
  const getTotalCheckedValue = (items) => {
    return items
      .filter((item) => item.isChecked)
      .reduce((sum, item) => sum + item.amount, 0);
  };
  const handleTotalAmount = () => {
    const po =
      paymentOption.filter((item) => item.isChecked === true)[0] || null;
    let totalValue = other.totalAmount;

    totalValue = totalValue - po?.discount ?? 0;

    const damValue =
      damage.find((item) => item.isChecked === true)?.amount || 0;
    const ofpValue =
      outofProvince.find((item) => item.isChecked === true)?.amount || 0;
    const adValue =
      additionalDriver.find((item) => item.isChecked === true)?.amount || 0;
    const gtValue =
      glassTires.find((item) => item.isChecked === true)?.amount || 0;
    const emValue =
      extraMileage.find((item) => item.isChecked === true)?.amount || 0;
    const eqpValue = getTotalCheckedValue(equipment);

    const extTotal =
      damValue + ofpValue + adValue + gtValue + emValue + eqpValue;
    setExtraAmountTotal(extTotal ?? 0);
    setDamageTotal(damValue ?? 0);
    setAdditionalDriverTotal(adValue ?? 0);
    setGlassTiresTotal(gtValue ?? 0);
    setEquipmentTotal(eqpValue ?? 0);
    setOutofProvinceTotal(ofpValue ?? 0);
    setExtraMileageTotal(emValue ?? 0);
    const finalTotal =
      totalValue + damValue + ofpValue + adValue + gtValue + emValue + eqpValue;
    setAmountTotal(finalTotal);
  };

  useEffect(() => {
    handleTotalAmount();
  }, [
    other,
    damage,
    outofProvince,
    additionalDriver,
    glassTires,
    extraMileage,
    equipment,
    paymentOption,
  ]);

  const handleExtra = () => {
    setExtraBoll(!extraBoll);
  };

  const handleRadio = (e, i) => {
    let { name, value, checked } = e.target;
    if (name === "payOption") {
      const updatedData = paymentOption.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );

      setPaymentOption(updatedData);
      const po =
        paymentOption.filter((item) => item.isChecked === true)[0] || null;
      let totalValue = other.totalAmount;

      totalValue = totalValue - po.discount;

      setAmountTotal(totalValue);
    }
    if (name === "damage") {
      const updatedData = damage.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setDamage(updatedData);
    }
    if (name === "outofProvince") {
      const updatedData = outofProvince.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setOutofProvince(updatedData);
    }

    if (name === "additionalDriver") {
      const updatedData = additionalDriver.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setAdditionalDriver(updatedData);
    }

    if (name === "glassTires") {
      const updatedData = glassTires.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setGlassTires(updatedData);
    }

    if (name === "equipment") {
      const updatedData = equipment.map((item, index) =>
        i === index ? { ...item, isChecked: checked } : { ...item }
      );
      setEquipment(updatedData);
    }

    if (name === "extraMileage") {
      const updatedData = extraMileage.map((item, index) =>
        i === index
          ? { ...item, isChecked: checked }
          : { ...item, isChecked: false }
      );
      setExtraMileage(updatedData);
    }
  };

  const Base64Image = ({ base64String }) => {
    return (
      <div>
        <img
          src={base64String}
          alt="Base64 Image"
          style={{ width: "100%", height: "auto" }}
          className="imgbox_renter"
        />
      </div>
    );
  };
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const data = formFieldValueMap;
    const vehicle = data?.renterVehicleInfo || {};
    const amount = data?.renterAmountDetails || {};
    const driver = data?.driverInfo || {};
    const itinerary = data?.itinerary || {};
    const carImage = vehicle.imgUrl
      ? `<img src="${vehicle.imgUrl}" alt="Vehicle" style="max-width:100%;max-height:120px;display:block;margin:0 auto;" />`
      : '';

    const html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Reservation - ${data?.title || ''}</title>
        <style>
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #333; font-size: 13px; background: #fff; }
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 3px solid #1976d2; padding-bottom: 15px; margin-bottom: 20px; }
          .header h1 { font-size: 22px; color: #1976d2; }
          .status { display: inline-block; padding: 5px 14px; border-radius: 20px; color: #fff; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; }
          .status-confirmed { background: #28a745; }
          .status-cancelled { background: #dc3545; }
          .grid { display: flex; gap: 25px; }
          .col-left { flex: 3; }
          .col-right { flex: 2; }
          .section { margin-bottom: 20px; }
          .section-title { font-size: 14px; font-weight: 700; color: #fff; background: #1976d2; padding: 8px 14px; border-radius: 6px; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.5px; }
          .card { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }
          .vehicle-card { display: flex; align-items: center; padding: 10px 15px; gap: 15px; }
          .vehicle-img { flex: 0 0 160px; text-align: center; }
          .vehicle-specs { flex: 1; }
          .spec-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 5px; }
          .spec-item { display: flex; align-items: center; gap: 6px; padding: 5px 8px; background: #f5f7fa; border-radius: 4px; font-size: 12px; }
          .spec-item .icon { font-size: 14px; }
          .spec-item .lbl { color: #777; }
          .spec-item .val { font-weight: 600; margin-left: auto; }
          table { width: 100%; border-collapse: collapse; }
          .card table td { padding: 7px 12px; border-bottom: 1px solid #f0f0f0; font-size: 12.5px; }
          .card table tr:last-child td { border-bottom: none; }
          td.lbl { color: #666; width: 55%; }
          td.val { text-align: right; font-weight: 600; }
          .indent td.lbl { padding-left: 28px; font-size: 12px; color: #888; }
          .row-total { background: #f5f7fa; }
          .row-total td { font-weight: 700 !important; font-size: 13.5px !important; color: #1976d2; }
          .row-blue td { color: #1976d2; font-weight: 600; }
          .row-red td { color: #dc3545; font-weight: 600; }
          .row-highlight { background: #e8f5e9; }
          .row-highlight td { font-weight: 700; }
          .info-card table td { padding: 8px 12px; }
          .info-card table td.lbl { font-weight: 600; color: #555; width: 40%; }
          .info-card table td.val { text-align: left; font-weight: 400; color: #333; }
          .vehicle-title { font-size: 16px; font-weight: 700; color: #1976d2; margin-bottom: 10px; }
          @media print {
            body { padding: 10px; margin: 0; }
            .section { break-inside: avoid; }
            .section-title { font-size: 11px; padding: 5px 10px; margin-bottom: 6px; }
            .card table td { padding: 4px 8px; font-size: 11px; }
            .spec-item { font-size: 10px; padding: 3px 5px; }
            .grid { gap: 10px; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>${data?.title || 'Reservation Details'}</h1>
          <span class="status ${data?.reservationStatus === 'Cancelled' ? 'status-cancelled' : 'status-confirmed'}">
            ${data?.reservationStatus || 'Confirmed'}
          </span>
        </div>

        <div class="section">
          <div class="section-title">Vehicle Information | ${vehicle.title || ''}</div>
          <div class="card">
            <div class="vehicle-card">
              <div class="vehicle-img">
                ${carImage}
              </div>
              <div class="vehicle-specs">
                <div class="spec-grid">
                  <div class="spec-item"><span class="icon">👥</span><span class="lbl">Passengers</span><span class="val">${vehicle.passenger || '-'}</span></div>
                  <div class="spec-item"><span class="icon">💼</span><span class="lbl">Luggage</span><span class="val">${vehicle.luggage || '-'}</span></div>
                  <div class="spec-item"><span class="icon">⚙️</span><span class="lbl">Transmission</span><span class="val">${vehicle.transmission || '-'}</span></div>
                  <div class="spec-item"><span class="icon">🚪</span><span class="lbl">Doors</span><span class="val">${vehicle.doors || '-'}</span></div>
                  <div class="spec-item"><span class="icon">❄️</span><span class="lbl">AC</span><span class="val">${vehicle.ac || '-'}</span></div>
                  <div class="spec-item"><span class="icon">🏎️</span><span class="lbl">Speed</span><span class="val">${vehicle.passenger || '-'}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-left">
            <div class="section">
              <div class="section-title">Amount Breakdown</div>
              <div class="card">
                <table>
                  <tr><td class="lbl">Before Taxes</td><td class="val">$ ${formatAmount(amount.baseRate)}</td></tr>
                  <tr><td class="lbl" style="color:#999;font-size:12px">${amount.daysString || ''}</td><td></td></tr>
                  <tr><td class="lbl"><strong>Extras</strong></td><td class="val">$ ${formatAmount(amount.extraAmount)}</td></tr>
                  <tr class="indent"><td class="lbl">Damage Protection (${amount.damagePro?.title || '-'})</td><td class="val">$ ${formatAmount(amount.damagePro?.amount)}</td></tr>
                  <tr class="indent"><td class="lbl">Additional Driver (${amount.additionalDriverDetails?.title || '-'})</td><td class="val">$ ${formatAmount(amount.additionalDriverDetails?.amount)}</td></tr>
                  <tr class="indent"><td class="lbl">Glass & Tire (${amount.extrasGlassDetails?.title || '-'})</td><td class="val">$ ${formatAmount(amount.extrasGlassDetails?.amount)}</td></tr>
                  <tr class="indent"><td class="lbl">Equipment (${amount.equipmentDetails?.title || '-'})</td><td class="val">$ ${formatAmount(amount.equipmentDetails?.amount)}</td></tr>
                  <tr class="indent"><td class="lbl">Out of Province (${amount.outOfProvinceDetails?.title || '-'})</td><td class="val">$ ${formatAmount(amount.outOfProvinceDetails?.amount)}</td></tr>
                  <tr class="indent"><td class="lbl">Extra Mileage (${amount.extraMileageDetails?.title || '-'})</td><td class="val">$ ${formatAmount(amount.extraMileageDetails?.amount)}</td></tr>
                  <tr><td class="lbl">Fees</td><td class="val">$ ${formatAmount(amount.fees)}</td></tr>
                  <tr><td class="lbl">Underage Driver Fees</td><td class="val">$ ${formatAmount(amount.underageDriverFee)}</td></tr>
                  <tr><td class="lbl">Airport Facility Charge</td><td class="val">$ ${formatAmount(amount.airportSurcharge)}</td></tr>
                  <tr><td class="lbl">Concession Fee</td><td class="val">$ ${formatAmount(amount.airportConcession)}</td></tr>
                  <tr><td class="lbl">After Hour Fee</td><td class="val">$ ${formatAmount(amount.afterHourFee)}</td></tr>
                  <tr><td class="lbl">After Hour Dropoff Fee</td><td class="val">$ ${formatAmount(amount.afterHourDropoffFee)}</td></tr>
                  <tr><td class="lbl">Estimated Taxes</td><td class="val">$ ${formatAmount(amount.tax)}</td></tr>
                  <tr class="row-total"><td class="lbl">Total Amount</td><td class="val">$ ${formatAmount(amount.totalAmount)}</td></tr>
                  <tr class="row-blue"><td class="lbl">Total without extras</td><td class="val">$ ${formatAmount(amount.totalAmount)}</td></tr>
                  <tr class="row-highlight"><td class="lbl">Pay on arrival</td><td class="val">$ ${formatAmount(amount.payOnArrival)}</td></tr>
                  <tr class="row-red"><td class="lbl">Limited Kilometers</td><td class="val">${amount.limitedKilometers || '-'}</td></tr>
                </table>
              </div>
            </div>
          </div>

          <div class="col-right">
            <div class="section">
              <div class="section-title">Driver Information</div>
              <div class="card info-card">
                <table>
                  <tr><td class="lbl">Name</td><td class="val">${driver.name || '-'}</td></tr>
                  <tr><td class="lbl">Email</td><td class="val">${driver.emailId || '-'}</td></tr>
                  <tr><td class="lbl">Contact</td><td class="val">${driver.contact || '-'}</td></tr>
                  <tr><td class="lbl">Address</td><td class="val">${driver.address || '-'}</td></tr>
                  <tr><td class="lbl">Flight/Special</td><td class="val">${driver.flight || '-'}</td></tr>
                </table>
              </div>
            </div>

            <div class="section">
              <div class="section-title">Itinerary</div>
              <div class="card info-card">
                <table>
                  <tr><td class="lbl">Pickup</td><td class="val">${itinerary.pickup || '-'}</td></tr>
                  <tr><td class="lbl">Dropoff</td><td class="val">${itinerary.dropoff || '-'}</td></tr>
                  <tr><td class="lbl">Location</td><td class="val">${itinerary.location || '-'}</td></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
      }, 500);
    };
  };

  const handleSyncToSofiac = () => {
    syncToSofiac({
      reservationId: formFieldValueMap?.id,
      authName: formFieldValueMap?.authName,
      authKey: formFieldValueMap?.authKey,
      data: formFieldValueMap
    });
  };

  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative sub-header ">
        <div className="maintitlediv">
          <div className="ml-3">
            <h4 className="pagetitle">View Reservations</h4>
          </div>
          <div className="buttonarea">
            <Button
              tooltip={"Print Reservation"}
              tooltipOptions={{ position: "left" }}
              label={"Print"}
              icon={"pi pi-print"}
              className={`p-button`}
              style={{ borderRadius: "10px", marginRight: "10px" }}
              onClick={handlePrint}
            />
            {/* <Button
              tooltip={"Sync To Sofiac"}
              tooltipOptions={{ position: "left" }}
              label={"Sync To Sofiac"}
              className={`p-button`}
              style={{ borderRadius: "10px", marginRight: "5px" }}
              onClick={handleSyncToSofiac}
            /> */}
            <Button
              tooltip={"Back to Reservations"}
              tooltipOptions={{ position: "left" }}
              label={"Back to Reservations"}
              // icon={"pi pi-arrow-left"}
              className={`p-button `}
              style={{ borderRadius: "10px" }}
              onClick={navigateToReservationsReservationsScreen}
            />
          </div>
        </div>
      </div>
    );
  };
  const panelHeaderLeftToggle = (options, showLastUpdated = false) => (
    <div
      className={`${options.className} `}
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div>
        {options.togglerElement}
          <span className="p-panel-title ml-2">{options.titleElement}</span>
        {options.icons}
      </div>
    </div>
  );

  return (
    <Container maxWidth="lg">
      <Breadcrumb list={ReservationsReservationsBreadcrumb} />
      <EzToast {...getToastProps()} />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Typography className="responsive-title">
              {formFieldValueMap?.title}
            </Typography>
            <Grid container spacing={2}>
              <Grid item sx={12} lg={8}>
                <Typography className="headbgblue" variant="h6">
                  Selected Vehicle Information
                  <span className={formFieldValueMap?.reservationStatus === "Cancelled" ? "status-cancelled" : "status-confirmed"}>
                    {formFieldValueMap?.reservationStatus || "Confirmed"}
                  </span>
                  {/* <span className={formFieldValueMap?.syncedToSofiac ? "status-confirmed" : "status-cancelled"} style={{ marginLeft: "10px" }}>
                    Synced To Sofiac: {formFieldValueMap?.syncedToSofiac ? "Yes" : "No"}
                  </span> */}
                </Typography>

                <Grid container spacing={2}>
                  <Grid item sx={12} sm={5}>
                    <Box>
                      <Base64Image
                        base64String={
                          formFieldValueMap?.renterVehicleInfo?.imgUrl
                        }
                      />
                    </Box>
                    <p className="vantype">{formFieldValueMap?.renterVehicleInfo?.title}</p>
                    <Box className="vandetails">
                      <ul>
                        <li>
                          <Diversity3Icon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.passenger}
                          </span>
                        </li>
                        <li>
                          <BusinessCenterIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.luggage}
                          </span>
                        </li>
                        <li>
                          <ManageAccountsIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.transmission}
                          </span>
                        </li>
                        <li>
                          <img src={CardICON} />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.doors}
                          </span>
                        </li>
                        <li>
                          <HeatPumpIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.ac}
                          </span>
                        </li>
                        <li>
                          <SpeedIcon />
                          <span>
                            {formFieldValueMap?.renterVehicleInfo?.passenger}
                          </span>
                        </li>
                      </ul>
                    </Box>
                    <Grid item xs={12} marginTop={"30px"}>
                      <Button
                        type="button"
                        className="text-center"
                        onClick={handleSendConfirmationEmail}
                      >
                        Send confirmation Email
                      </Button>
                    </Grid>

                    <Grid item xs={12} marginTop={"30px"}>
                      <EzControlledDropDowntWithFloatingLabel
                        name="paymentStatus"
                        control={control}
                        rules={
                          getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                        }
                        optionLabel={"name"}
                        optionValue={"id"}
                        options={paymentStatusDD}
                        isError={errors["paymentStatus"]}
                        errorMsg={getFormErrorMessage("paymentStatus")}
                        label="Payment Status"
                        labelClassName={"ml-2"}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <EzControlledInputAreaWithFloatingLabel
                        name="note"
                        control={control}
                        label="Additional Notes"
                        type="text"
                        rules={
                          getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                        }
                        isError={errors["note"]}
                        errorMsg={getFormErrorMessage("note")}
                      />
                    </Grid>

                    <div className={"make-flex mt-3 mr-2"}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "end",
                        }}
                      >
                        <React.Fragment>
                          <div
                            style={{
                              margin: "15px 0px 15px 10px",
                              minWidth: "100px",
                            }}
                          >
                            <Button
                              type="submit"
                              label={isEdit ? "Update" : "Save"}
                              className="mt-2 p-button-raised"
                            />
                          </div>
                        </React.Fragment>
                      </div>
                    </div>
                  </Grid>
                  <Grid item sx={12} sm={7} className="boxmidright">
                    <Typography variant="h6" className="sub">
                      Total Amount
                      <span>
                        ${" "}
                        {formatAmount(formFieldValueMap?.renterAmountDetails?.totalAmount)}
                      </span>
                    </Typography>

                    <table className="tbleforRenter">
                      <tbody>
                        <tr className="rowfont">
                          <td colSpan={2}>Before Taxes</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.baseRate)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={3}>
                            {formFieldValueMap?.renterAmountDetails?.daysString}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ padding: 0 }}>
                            <Panel
                              ref={ref}
                              header="Extras"
                              className=" w-100"
                              toggleable
                              headerTemplate={(options) =>
                                panelHeaderLeftToggle(options, true)
                              }
                              expandIcon="pi pi-angle-right"
                              collapseIcon="pi pi-angle-down"
                            >
                              <table className="tbleforRenters" style={{ width: '100%' }}>
                                <tbody>
                                  <tr className="rowfont">
                                    <td colSpan={2}>Extras </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.extraAmount)}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Damage Protection Plans</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.damagePro?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.damagePro?.amount)}{" "}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Additional Driver(s)</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.additionalDriverDetails?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.additionalDriverDetails?.amount)}{" "}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Glass & Tire</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.extrasGlassDetails?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.extrasGlassDetails?.amount)}{" "}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Equipment</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.equipmentDetails?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.equipmentDetails?.amount)}{" "}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Out of Province</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.outOfProvinceDetails?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.outOfProvinceDetails?.amount)}
                                    </td>
                                  </tr>
                                  <tr className="rowfont2">
                                    <td>Extra Mileage</td>
                                    <td>
                                      {
                                        formFieldValueMap?.renterAmountDetails
                                          ?.extraMileageDetails?.title
                                      }{" "}
                                    </td>
                                    <td className="textr">
                                      ${" "}
                                      {formatAmount(formFieldValueMap?.renterAmountDetails?.extraMileageDetails?.amount)}{" "}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Panel>
                          </td>
                        </tr>

                        <tr className="rowfont">
                          <td colSpan={2}>Fees</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.fees)}
                          </td>
                        </tr>

                        <tr className="rowfont">
                          <td colSpan={2}>Underage Driver Fees</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.underageDriverFee)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>
                            Airport Facility Charge Total for 3
                          </td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.airportSurcharge)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Concession Fee</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.airportConcession)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>After Hour Fee</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.afterHourFee)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>After Hour Dropoff Fee</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.afterHourDropoffFee)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Estimated Taxes</td>
                          <td className="textr">
                            $ {formatAmount(formFieldValueMap?.renterAmountDetails?.tax)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Total amount of your booking</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.totalAmount)}
                          </td>
                        </tr>
                        <tr className="rowfont blue">
                          <td colSpan={2}>Total without extras</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.totalAmount)}
                          </td>
                        </tr>
                        <tr className="rowfont">
                          <td colSpan={2}>Pay on arrival</td>
                          <td className="textr">
                            ${" "}
                            {formatAmount(formFieldValueMap?.renterAmountDetails?.payOnArrival)}
                          </td>
                        </tr>
                        <tr className="rowfont red">
                          <td colSpan={2}>Limited Kilometers</td>
                          <td className="textr">
                            {
                              formFieldValueMap?.renterAmountDetails
                                ?.limitedKilometers
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sx={12} lg={4}>
                <Typography className="headbgblue" variant="h6">
                  Sofiac Details
                </Typography>
                <table className="tbleforRenter">
                  <tbody>
                    <tr className="rowfont">
                      <td>
                        <b>Sofiac Synced:</b>
                      </td>
                      <td className="textl">
                        {sofiacReservationStatus?.sofiac_synced_label ?? "-"}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Sofiac Cancel Status:</b>
                      </td>
                      <td className="textl">
                        {sofiacReservationStatus?.sofiac_cancel_synced_label ?? "-"}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Sofiac Confirmation ID:</b>
                      </td>
                      <td className="textl">
                        {sofiacReservationStatus?.sofiac_confirmation_id ?? "not synced"}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Typography className="headbgblue" variant="h6">
                  Driver Information
                </Typography>
                <table className="tbleforRenter">
                  <tbody>
                    <tr className="rowfont">
                      <td>
                        <b>Name:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.name}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Email ID:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.emailId}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Contact:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.contact}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Address:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.address}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td>
                        <b>Flight/Special:</b>
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.driverInfo?.flight}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Typography className="headbgblue" variant="h6">
                  Itinerary
                </Typography>

                <table className="tbleforRenter">
                  <tbody>
                    <tr className="rowfont">
                      <td>
                        <b>Pickup</b>
                      </td>
                      <td className="textl">
                        <b>Dropoff</b>
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td className="textl">
                        {formFieldValueMap?.itinerary?.pickup}
                      </td>
                      <td className="textl">
                        {formFieldValueMap?.itinerary?.dropoff}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2}>
                        {" "}
                        <b>Pickup & Dropoff Location</b>
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2} className="textl">
                        {formFieldValueMap?.itinerary?.location}
                      </td>
                    </tr>
                    <tr className="rowfont">
                      <td colSpan={2} className="textl">
                        {formFieldValueMap?.voucherUrl ? (
                          <a 
                            href={formFieldValueMap.voucherUrl} 
                            download="voucher.pdf"
                          >
                            Download Voucher
                          </a>
                        ) : (
                          <span>No Voucher Available</span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Typography className="headbgblue" variant="h6">
                  Cancellation
                </Typography>
                <Grid item xs={12} marginTop={"30px"}>
                  <EzControlledDropDowntWithFloatingLabel
                    name="reasonCancel"
                    control={control}
                    rules={getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE}
                    optionLabel={"name"}
                    optionValue={"id"}
                    options={cancelResonsDD}
                    isError={errors["reasonCancel"]}
                    errorMsg={getFormErrorMessage("reasonCancel")}
                    label="Reason for Cancellation"
                    labelClassName={"ml-2"}
                  />
                </Grid>
                {cancellation == "6" && (
                  <Grid item xs={12}>
                    <EzControlledInputAreaWithFloatingLabel
                      name="reasonOtherDetails"
                      control={control}
                      label="Others"
                      type="text"
                      rules={
                        getFormBaseValidationRule().DEFAULT.DO_NOT_VALIDATE
                      }
                      isError={errors["reasonOtherDetails"]}
                      errorMsg={getFormErrorMessage("reasonOtherDetails")}
                    />
                  </Grid>
                )}
                <React.Fragment>
                  <div
                    style={{ margin: "0px 0px 15px 0px", maxWidth: "100px" }}
                  >
                    <Button
                      type="button"
                      label={"Cancel"}
                      severity="danger"
                      onClick={handleCancel}
                      className="mt-2 p-button-raised danger"
                    />
                  </div>
                </React.Fragment>
              </Grid>
            </Grid>

            {isEdit && (
              <Grid className="modsection" container spacing={2}>
                {editMode?.map((item) => (
                  <Grid item xs={12} sm={3} key={item.name}>
                    <EzControlledInputWithFloatingLabel
                      name={item?.name}
                      control={control}
                      disabled={item?.disabled}
                      label={item?.label}
                      type={item?.type}
                      rules={item?.rule}
                      isError={errors[item?.name]}
                      errorMsg={getFormErrorMessage(item?.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </form>
        </div>
      </div>
    </Container>
  );
};

export default ViewReservationsReservationsComponent;
